<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Storage/MaterialAllot/'+this.houseId">
          <el-button type="primary" size="mini">材料调拨</el-button>
        </router-link>
      </div>

      <label class="label-name">调出仓库：</label>
      <el-select size="small" class="organization-select" v-model="houseId"
        placeholder="请选择仓库">
        <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column label="调拨单号">
        <template slot-scope="scope">
          <a href="javascript:void(0)" @click="ShowMaterialInDetail(scope.row)">{{ scope.row.number }}</a>
        </template>
      </el-table-column>

      <el-table-column prop="outHouse.name" label="调出仓库">
      </el-table-column>
      <el-table-column prop="inHouse.name" label="调入仓库">
      </el-table-column>
      <el-table-column label="调拨操作员" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="调拨时间">
      </el-table-column>
      <!-- <el-table-column prop="total" label="总金额(元)" width="80">
      </el-table-column> -->
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="ShowMaterialInDetail(scope.row)" type="primary">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <material-allot-detail v-on:hideDetail="hideDetail()" :detailStatus="detailStatus" :materialInData="materialInData"></material-allot-detail>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import MaterialAllotDetail from '@/page/storage/components/materialAllotDetail'
  export default {
    components: {
      UserInfo,
      MaterialAllotDetail,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 入库单明细详情
        detailStatus: false,
        materialInData: "",

        houseId: "",
        depId: "",
        houseList: "",

        organizationListData: [],
        noSelectOrganization: true,
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    created() {
      if (this.$route.params.houseId) {
        this.houseId = this.$route.params.houseId / 1
      }
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      // 获取仓库列表
      this.getHouseList()
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }
    },
    methods: {
      hideDetail() {
        this.detailStatus = false
      },
      // 显示入库单详情
      ShowMaterialInDetail(row) {
        this.materialInData = row
        this.detailStatus = true
      },
      // 获取仓库列表
      getHouseList() {
        ajax.get('/storage/house/list', {
          'depId': this.depId
        }, (res) => {
          this.loading = false
          this.houseList = res.vo.array

          // 获取库存
          this.getLists()
        })
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        if (!this.houseId && this.houseList.length > 0) {
          this.houseId = this.houseList[0].id
        }
        if (!this.houseId) {
          return
        }
        this.loading = true

        ajax.get('/storage/material/allot/list', {
          "houseId": this.houseId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getFilterData()
        })
      },
    },
    watch: {
      "houseId"() {
        this.getLists()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/storage/materialAllotList.vue